/**
 * PremiumUpgradePrompt.tsx
 * 
 * This component displays a prompt for free tier users to upgrade to premium
 * in order to access certain features like email sharing.
 * 
 * Changes:
 * - Extracted from ShareDialog.tsx to improve component modularity
 */

import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function PremiumUpgradePrompt() {
  return (
    <div className="p-4 mt-4 bg-muted border rounded-md">
      <p className="text-sm mb-3">Upgrade to premium to share posits directly via email.</p>
      <Link to="/pricing">
        <Button variant="default" size="sm">
          Upgrade
        </Button>
      </Link>
    </div>
  );
} 